const systemMessages = {
  // mensagens da agenda
  "cofre-invalid": {
    message: `Encontramos um problema ao carregar o token do usuário.
      A resposta recebida é inválida.`,
    icon: "mdi-alert",
    color: "negative",
  },
  "google-decrypt-error": {
    message: `Encontramos um problema ao tentar acessar sua conta do Google.
      Por favor, faça login novamente.`,
    icon: "mdi-alert",
  },

  // mensagens de bi
  "pj-not-found": {
    message: `Não conseguimos encontrar nenhum processo com o número
      de PJ: $params. Verifique se o número está correto e tente novamente.`,
    icon: "mdi-alert",
    color: "negative",
  },
  "bi-errsend-emailuser": {
    // todo
    message:
      "Erro ao tentar enviar e-mail, usuário logado não possui e-mail cadastrado",
  },
  "bi-problem-nosendmail": {
    message: `Houve um problema e o e-mail não pôde ser enviado.
    Verifique sua conexão com a internet e suas configurações de envio de e-mail.`,
  },
  "bi-email-sucess": { message: `O e-mail foi enviado com sucesso!` },
  "bi-required-fields": { message: "Campos obrigatórios não preenchidos" }, // todo

  // mensagens do dashboard
  "dash-nodata-or-filterwrong": {
    message: `Não encontramos dados disponíveis ou o filtro selecionado está incorreto.
      Verifique suas configurações de filtro e tente novamente.`,
  },

  // mensagens do calendario
  "sch-errload-calendar": {
    message: "Encontramos um erro ao carregar o calendário: ",
  },
  "sch-nocodpe-insert": {
    message: `Parece que nenhum código de pessoa foi inserido.
    Insira o código necessário e tente novamente.`,
  },

  // mensagens do manutenção
  "man-noname-panel": {
    message: `O campo obrigatório ‘Nome do painel’ não foi preenchido.`,
  },
  "man-noacess-panel": {
    message: `O campo obrigatório ‘Acesso do painel’ não foi preenchido.`,
  },
  "man-noarq-3c": {
    message: `Não conseguimos encontrar o arquivo no ARQ-3C Server.
    Verifique se o arquivo existe e tente novamente.`,
  },
  "man-errcopy-graf": {
    message: `Encontramos um problema ao copiar o gráfico.
    Verifique se o gráfico está válido e tente novamente.`,
  },
  "man-erredit-graf": {
    message: `Encontramos um problema ao editar o gráfico.
    Verifique se o gráfico está válido e tente novamente.`,
  },
  "man-json-invalid": {
    message: `Encontramos um problema com o JSON fornecido.
    Verifique se o JSON está válido e tente novamente.`,
  },
  "man-alt-panelsave": {
    message: `As alterações feitas no painel foram salvas com sucesso!`,
  },
  "man-nointer-arqpanel": {
    message: `Não conseguimos interpretar o arquivo do painel.
      Verifique se o arquivo está no formato correto e tente novamente.`,
  },
  "man-err-json-invalid": {
    message: `Encontramos um problema com o JSON fornecido.
    Verifique se o JSON está válido e tente novamente.`,
  },
  "man-panel-invalid": {
    message: `Encontramos um problema com o painel. Parece que ele é inválido.
    Verifique se as informações estão corretas e tente novamente.`,
  },

  // mensagens do preferências
  "pref-need-img": {
    message: `Precisamos que o arquivo seja uma imagem.
    Verifique se o arquivo está no formato correto e tente novamente.`,
  },
  "pref-apply-sucess": {
    message: `Suas preferências foram aplicadas com sucesso!`,
  },

  // mensagens do processo
  "pro-no-pj": {
    message: `Não conseguimos encontrar um número de PJ associado a esse processo.
    Verifique se as informações estão corretas e tente novamente.`,
  },
  "pro-noacess-arqdead": {
    message: `Parece que você não possui acesso ao arquivo morto. `,
  },
  "pro-erracess-arqopen": {
    message: `Encontramos um erro ao abrir o arquivo. Tente novamente mais tarde. `,
  },
  "pro-noarq-3c": {
    message: `Não conseguimos encontrar o arquivo no ARQ-3C Server.
    Verifique se o arquivo existe e tente novamente.`,
  },
  "pro-enable-popups": {
    message: `Para baixar arquivos neste dispositivo ative a opção de pop-ups. Essa configuração permitirá que você tenha acesso aos recursos
      de download.`,
  },
  "pro-nopossible-acess-arq": {
    message: `Não conseguimos obter o arquivo solicitado. Isso pode ocorrer por diferentes motivos: o arquivo pode estar inacessível, não existir
      ou o servidor do ARQ pode estar inacessível ou desligado.`,
  },

  // mensagens do provider
  "prov-field-nofilled": {
    message: `Parece que você não preencheu todos os campos.`,
  },
  "prov-sigla-nofilled": {
    message: `O campo obrigatório 'Sigla' não foi preenchido.`,
  },
  "prov-desc-nofilled": {
    message: "O campo obrigatório 'Descrição' não foi preenchido.",
  },
  "prov-user-nofilled": {
    message: "O campo obrigatório 'Usuário' não foi preenchido.",
  },
  "prov-provider-nofilled": {
    message: "O campo obrigatório 'Fonte de dados' não foi preenchido.",
  },
  "prov-password-nofilled": {
    message: "O campo obrigatório 'Senha' não foi preenchido.",
  },
  "prov-database-name-nofilled": {
    message: "Campo obrigatório 'Nome do banco de dados' não foi preenchido.",
  },
  // mensagens do sistema
  "access-denied": {
    message: "Acesso negado.",
    icon: "mdi-alert",
    color: "negative",
  },
  "auth-error": {
    message: `Encontramos um erro na autenticação da chamada: $params`,
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "empty-response": {
    message: `Resposta vazia para a chamada: $params.
      Verifique sua conexão com a internet e tente novamente.`,
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "change-pwd-different-pwd": {
    message: "Senhas não conferem",
    icon: "mdi-alert",
    color: "warning",
    textColor: "grey-10",
  },
  "change-pwd-old-pwd-mismatch": {
    message: "Senha antiga não confere",
    icon: "mdi-alert",
    color: "warning",
    textColor: "grey-10",
  },
  "change-pwd-required-fields": {
    message: "Todos os campos devem ser preenchidos",
    icon: "mdi-alert",
    color: "warning",
    textColor: "grey-10",
  },
  "change-pwd-same-pwd": {
    message: "A nova senha deve ser diferente da atual",
    icon: "mdi-alert",
    color: "warning",
    textColor: "grey-10",
  },
  "change-pwd-success": {
    message: "Senha alterada com sucesso!",
    icon: "mdi-check",
  },
  "invalid-chart": {
    message: "Gráfico $params inválido ou não encontrado",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "invalid-response": {
    message: "Resposta inválida para a chamada: $params",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "invalid-search": {
    message: "Pesquisa inválida: número incorreto de argumentos.",
    icon: "mdi-alert",
  },
  "javascript-error": {
    message: "Erro de javascript: $params",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "request-timeout": {
    message: "O servidor não respondeu a tempo a chamada: $params",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "required-user-password": {
    message: "Usuário e senha são campos obrigatórios",
    icon: "mdi-alert",
  },
  "missing-params": {
    message: "Faltando parâmetros para a função: $params",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "no-server-response": {
    message: "O servidor não respondeu a tempo",
    title: "Erro 504 - Gateway Timeout",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
    html: true,
  },
  "no-system-access": {
    message: "Usuário não possui acesso a nenhum módulo do sistema.",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "open-file-error": {
    message: "Erro ao abrir arquivo",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
  "wrong-response": {
    message: "Resposta errada para a chamada: $params",
    icon: "mdi-alert",
    display: "dialog",
    type: "error",
    persistent: true,
  },
};

export default systemMessages;
